'use client';

import type { BlockRenderProps } from '../../types';
import { buildDirectContactActions } from './buildDirectContactActions';
import { ReservationChannelShell } from './ReservationChannelShell';

/** Direct contact — WhatsApp and/or phone CTAs from filled fields. */
export function ReservationMessengerBook(props: BlockRenderProps) {
  const { actions, nextChromeKey } = buildDirectContactActions(
    props.block,
    props.locale,
    props.editable,
  );
  return (
    <ReservationChannelShell
      {...props}
      channel="direct"
      actions={actions}
      nextChromeKey={nextChromeKey}
    />
  );
}
